import {Button, Modal} from "react-bootstrap";
import {Field, Formik} from "formik";
import * as Yup from "yup";
import {useAddTicket} from "../../../hooks/useTicket";
import {useSelector} from "react-redux";
import {userRoleList} from "../../../utils/constants";

const AddTicketModal = ({openModal, toggleModal}) => {
  const {onAddTicket} = useAddTicket();
  const {selectedRole} = useSelector((state) => state.auth.auth);

  const categories = [
    {title: "Problème de prestation", value: 2},
    {
      title:
        selectedRole === userRoleList.TECHNICIAN
          ? "Conflit avec un client"
          : "Conflit avec un prestataire",
      value: 3,
    },
    {title: "Autre problème", value: 1},
  ];

  const handleReviewSubmit = async (values) => {
    // Add your review submission logic here
    await onAddTicket({
      message: values.message,
      title: values.title,
      categoryId: values.category,
    });
    toggleModal(false);
  };
  return (
    <Modal
      className="modal fade"
      show={openModal}
      onHide={toggleModal}
      centered
      size="md"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title text-[#1A64B9] font-semibold">
            Soumettre une réclamation
          </h4>
          <Button
            variant=""
            type="button"
            className="close"
            onClick={() => toggleModal(false)}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !py-3 !px-0 h-fit max-h-[70vh] overflow-scroll overflow-style-none">
          <div className="w-full flex flex-col justify-center items-center gap-2 ">
            <div className="flex flex-col justify-center items-center "></div>

            <Formik
              initialValues={{category: "", message: "", title: ""}}
              validationSchema={Yup.object({
                title: Yup.string()
                  .required("Champ obligatoire")
                  .min(5, "Le titre doit contenir au moins 5 caractères"),
                message: Yup.string()
                  .required("Le message est requis")
                  .min(5, "Le message doit contenir au moins 5 caractères"),
                category: Yup.number().required("Champ Obligatoire"),
              })}
              onSubmit={handleReviewSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                handleChange,
              }) => (
                <form onSubmit={handleSubmit} className="w-full">
                  <div className="w-full !px-6 !py-3">
                    <div className="form-group ">
                      <label className="block font-bold text-sm text-[#3D4465]">
                        Titre
                      </label>
                      <Field
                        type="text"
                        placeholder="Titre"
                        className="form-control"
                        name="title"
                      />
                      {errors.title && touched.title && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.title}
                        </div>
                      )}
                    </div>
                    <div className="form-group ">
                      <label className="block font-bold text-sm text-[#3D4465]">
                        Catégorie
                      </label>
                      <select
                        className="form-control  custom-select-arrow "
                        name="category"
                        value={values.category}
                        onChange={handleChange}
                      >
                        <option value="" disabled hidden>
                          Choisir une catégorie
                        </option>
                        {categories?.map((category) => (
                          <option key={category.value} value={category.value}>
                            {category.title}
                          </option>
                        ))}
                      </select>
                      {errors.category && touched.category && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.category}
                        </div>
                      )}
                    </div>
                    <div className="form-group mb-4">
                      <label className="block font-bold text-sm text-[#3D4465]">
                        Message
                      </label>
                      <Field
                        as="textarea"
                        rows={3}
                        className="form-control placeholder:text-sm"
                        name="message"
                        placeholder="Votre message ici..."
                      />
                      {errors.message && touched.message && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.message}
                        </div>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-2 mt-4">
                      <button
                        type="button"
                        onClick={() => toggleModal(false)}
                        className="!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase"
                      >
                        Ignorer
                      </button>
                      <button
                        type="submit"
                        className="!rounded-md  !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    uppercase"
                      >
                        Envoyer
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AddTicketModal;
